import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3337 6.66659C13.3337 10.6666 8.00033 14.6666 8.00033 14.6666C8.00033 14.6666 2.66699 10.6666 2.66699 6.66659C2.66699 5.2521 3.2289 3.89554 4.22909 2.89535C5.22928 1.89516 6.58584 1.33325 8.00033 1.33325C9.41481 1.33325 10.7714 1.89516 11.7716 2.89535C12.7718 3.89554 13.3337 5.2521 13.3337 6.66659Z",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 8.66675C9.10457 8.66675 10 7.77132 10 6.66675C10 5.56218 9.10457 4.66675 8 4.66675C6.89543 4.66675 6 5.56218 6 6.66675C6 7.77132 6.89543 8.66675 8 8.66675Z",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIp;
